export default __webpack_public_path__ + "static/media/icon-route-coldchain.04f723c3.svg";